var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPickupSummary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "#FF5F14"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4429 16C21.4621 16 20.667 16.7951 20.667 17.7759C20.667 18.7567 21.4621 19.5518 22.4429 19.5518H27.667V55.6197C24.5973 56.794 22.4175 59.7674 22.4175 63.25C22.4175 67.7603 26.0738 71.4167 30.5841 71.4167C35.0945 71.4167 38.7508 67.7603 38.7508 63.25C38.7508 61.5988 38.2608 60.0621 37.4182 58.7773H58.5662C59.22 58.7773 59.7501 58.2472 59.7501 57.5934V38.9613C59.7501 38.3074 59.22 37.7773 58.5662 37.7773H52.7503V25.9415C52.7503 25.2876 52.2202 24.7576 51.5663 24.7576H35.2676C34.6137 24.7576 34.0836 25.2876 34.0836 25.9415V38.941L34.0834 38.9613V55.8689C33.2037 55.4511 32.2374 55.1859 31.2188 55.1076V17.7759C31.2188 16.7951 30.4237 16 29.4429 16H22.4429ZM38.2301 60.3333C38.5828 61.2463 38.7762 62.2385 38.7762 63.2759C38.7762 63.4808 38.7687 63.684 38.7538 63.8852H59.0406L64.3538 69.1983C65.0473 69.8919 66.1718 69.8919 66.8653 69.1983C67.5589 68.5048 67.5589 67.3804 66.8653 66.6868L61.032 60.8535C60.6989 60.5204 60.2472 60.3333 59.7762 60.3333H38.2301ZM37.6354 37.7255V28.3094H49.1985V37.7255H37.6354ZM37.6353 55.2255V41.3291H56.1983V55.2255H37.6353ZM35.2508 63.25C35.2508 65.8273 33.1615 67.9167 30.5841 67.9167C28.0068 67.9167 25.9175 65.8273 25.9175 63.25C25.9175 60.6727 28.0068 58.5833 30.5841 58.5833C33.1615 58.5833 35.2508 60.6727 35.2508 63.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickupSummary);
export default __webpack_public_path__ + "static/media/PickupSummary.72844277b7f95c454e48e795cfc0f5a4.svg";
export { ForwardRef as ReactComponent };